import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import FinalizeTpClientInvoiceBulkItem from '../../../Domain/FinalizeTpClientInvoiceBulkItem';
import {
  checkFinalizeComment,
  checkJobsNoLongerReadyChoice,
  getFinalizeRequest,
  getJobsNoLongerReadyChoiceOptions,
} from '../../../Helpers/finalizeJobsNoLongerReadyHelper';

// Finalize Selected: which invoices are selected on the page (SelectedInvoices, shown only), what to do with the shops
// on them that no longer pass the Ready for Invoicing rules, which starts on Remove, and a comment, required to keep
// them. The page binds getSelected, getSearchParameters and getAllItemsInTheSearchSetAreSelected to its selection.
export default class FinalizeSelectedTpClientInvoicesWindowDescription {
  static titleForEdit = 'Finalize Selected Client Invoices';
  static finishButtonLabel = 'Finalize';
  static itemType = FinalizeTpClientInvoiceBulkItem;
  static messageOnSuccess = 'Invoice(s) finalized.';
  static serviceFunction = (editedItem) => {
    const { SelectedInvoices, EvaluatorPaymentApprovalNote, ...item } = editedItem;
    return TpClientInvoiceService.FinalizeSelectedInvoice(
      getFinalizeRequest(item),
      FinalizeSelectedTpClientInvoicesWindowDescription.getSearchParameters(),
      FinalizeSelectedTpClientInvoicesWindowDescription.getSelected(),
      FinalizeSelectedTpClientInvoicesWindowDescription.getAllItemsInTheSearchSetAreSelected()
    );
  };

  static getSelected() {
    return null;
  }

  static getSearchParameters() {
    return null;
  }

  static getAllItemsInTheSearchSetAreSelected() {
    return null;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'SelectedInvoices',
          label: 'Client Invoices',
          className: 'col-12',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          // CD-5483: set by TpClientInvoiceAdmin.openFinalizeSelectedWindow; empty when no evaluator payment of the
          // invoices would need supervisor approval.
          fieldName: 'EvaluatorPaymentApprovalNote',
          label: 'Supervisor approval',
          className: 'col-12',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.EvaluatorPaymentApprovalNote,
        },
        {
          fieldName: 'JobsNoLongerReadyChoice',
          label: 'Shops No Longer Ready For Invoicing *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: () => getJobsNoLongerReadyChoiceOptions(),
          validityChecker: checkJobsNoLongerReadyChoice,
          info: 'For every selected invoice holding shops that no longer pass the Ready for Invoicing rules: their status changed, or they were marked uninvoiceable.',
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: checkFinalizeComment,
        },
      ],
    },
  ];
}
